import React, { Component } from "react";
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';

const format = 'HH:mm';

class ExportDeviceSettingsMobileStarterBatch extends Component {
  constructor(props) {
    super(props);

    // State to manage cards
    this.state = {
      cards: this.props.details.batches || [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.details.batches !== this.props.details.batches) {
      this.setState({ cards: this.props.details.batches });
    }
  }

  notifyParent = () => {
    const { cards } = this.state;
    if (this.props.handleUpdateSunBatch) {
      this.props.handleUpdateSunBatch(cards, this.props.index, this.props.day); // Send updated cards to the parent
    }
  };

  // Handler to add a new card
  handleAddCard = () => {
    const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const dayIndex = days.indexOf(this.props.day);

    const { cards } = this.state;
    let newStartTime = null;

    // If there's an existing batch, set the start time of the new batch to be 1 minutes after the last batch's stop time
    if (cards.length > 0) {
      const lastBatch = cards[cards.length - 1];
      if (lastBatch.stop_time) {
        const lastStopTime = moment(lastBatch.stop_time, format);
        newStartTime = lastStopTime.add(1, 'minutes').format(format);
      }
    }

    const newCard = {
      id: (dayIndex + 1) * 100 + cards.length + 1,
      duration: "",
      duration_minute: "",
      valves: {
        valve1: false,
        valve2: false,
        valve3: false,
        valve4: false,
        valve5: false,
        valve6: false,
      },
      on_cmd: "",
      off_cmd: "",
      start_time: newStartTime,
      stop_time: null,
      start_time_h: newStartTime ? parseInt(newStartTime.split(":")[0], 10) : null,
      start_time_m: newStartTime ? parseInt(newStartTime.split(":")[1], 10) : null,
    };

    this.setState({ cards: [...cards, newCard] }, this.notifyParent);
  };

  // Handler for duration input change
  handleDurationChange = (id, value) => {
    const updatedCards = this.state.cards.map((card) =>
      card.id === id ? { ...card, duration_minute: value, duration: value * 60 } : card
    );
    this.setState({ cards: updatedCards }, this.notifyParent);
  };


  handleTimeChangeBatchStartSun = (id, time, timeString) => {
    const { cards } = this.state;

    // Find the index of the current card
    const index = cards.findIndex((card) => card.id === id);

    if (index > 0) {
      // Get the stop time of the previous batch
      const prevCard = cards[index - 1];
      if (prevCard.stop_time) {
        const prevStopTime = moment(prevCard.stop_time, format);
        const newStartTime = moment(timeString, format);

        // Check if the new start time is less than or equal to the previous stop time
        if (!newStartTime.isAfter(prevStopTime)) {
          alert(`Start time must be at least 1 minutes after the previous batch's stop time (${prevCard.stop_time}).`);
          return; // Prevent the change
        }
      }
    }

    // Update the start time if valid
    const updatedCards = cards.map((card) =>
      card.id === id
        ? {
          ...card,
          start_time: timeString,
          start_time_h: parseInt(timeString.split(":")[0], 10),
          start_time_m: parseInt(timeString.split(":")[1], 10),
        }
        : card
    );

    this.setState({ cards: updatedCards }, this.notifyParent);
  };
  

  handleTimeChangeBatchStopSun = (id, time, timeString) => {
    const { cards } = this.state;

    const updatedCards = cards.map((card) =>
      card.id === id
        ? {
          ...card,
          stop_time: timeString,
          stop_time_h: parseInt(timeString.split(":")[0], 10),
          stop_time_m: parseInt(timeString.split(":")[1], 10),
        }
        : card
    );

    // Auto-adjust start time of the next batch, if applicable
    const index = cards.findIndex((card) => card.id === id);
    if (index !== -1 && index < cards.length - 1) {
      const nextCard = updatedCards[index + 1];
      const adjustedStartTime = moment(timeString, format).add(1, 'minutes').format(format);
      updatedCards[index + 1] = {
        ...nextCard,
        start_time: adjustedStartTime,
        start_time_h: parseInt(adjustedStartTime.split(":")[0], 10),
        start_time_m: parseInt(adjustedStartTime.split(":")[1], 10),
      };
    }

    this.setState({ cards: updatedCards }, this.notifyParent);
  };



  // Handler for checkbox change
  // handleCheckboxChange = (id, valve) => {
  //   const updatedCards = this.state.cards.map((card) =>
  //     card.id === id
  //       ? { ...card, valves: { ...card.valves, [valve]: !card.valves[valve] } }
  //       : card
  //   );
  //   this.setState({ cards: updatedCards }, this.notifyParent);
  // };

  handleCheckboxChange = (id, valve) => {
    const updatedCards = this.state.cards.map((card) => {
      if (card.id === id) {
        // Toggle the valve state
        const newValves = { ...card.valves, [valve]: !card.valves[valve] };

        // Compute the updated on_cmd and off_cmd
        const selectedValves = Object.keys(newValves).filter((key) => newValves[key]);
        const onCmds = selectedValves.map((v) => `R-${(parseInt(v.replace("valve", "")) * 2) - 1}`);
        const offCmds = selectedValves.map((v) => `R-${(parseInt(v.replace("valve", "")) * 2)}`);

        return {
          ...card,
          valves: newValves,
          on_cmd: onCmds.join("|"),
          off_cmd: offCmds.join("|"),
        };
      }
      return card;
    });

    this.setState({ cards: updatedCards }, this.notifyParent);
  };


  // Handler to remove a card
  handleRemoveCard = (id) => {
    const updatedCards = this.state.cards.filter((card) => card.id !== id);
    this.setState({ cards: updatedCards }, this.notifyParent);
  };





  render() {
    // Inline CSS styles
    const containerStyle = {
      marginTop: "20px",
    };

    const buttonStyle = {
      marginBottom: "20px",
    };

    const cardsContainerStyle = {
      display: "flex",
      overflowX: "auto",
      padding: "10px",
      gap: "15px",
    };

    const cardStyle = {
      flex: "0 0 200px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      borderRadius: "5px",
      padding: "15px",
      backgroundColor: "#fff",
    };

    const checkboxContainerStyle = {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      marginTop: "10px",
    };

    const checkboxLabelStyle = {
      display: "flex",
      alignItems: "center",
    };

    const textBoxStyle = {
      marginTop: "15px",
    };

    return (
      <div style={containerStyle}>
        <button className="btn btn-primary" style={buttonStyle} onClick={this.handleAddCard}>
          + Add Batch
        </button>

        {/* Horizontal Scrollable Container */}
        <div style={cardsContainerStyle}>
          {this.state.cards.map((card, index) => (
            <div key={card.id} className="card" style={cardStyle}>
              <div className="card-body">
                <h5 className="card-title">Batch {index + 1}</h5>

                {/* Checkboxes */}
                <div style={checkboxContainerStyle}>
                  {["valve1", "valve2", "valve3", "valve4", "valve5", "valve6"].map(
                    (valve, valveIndex) => (
                      <label key={valve} style={checkboxLabelStyle}>
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          checked={card.valves?.[valve] || false}
                          onChange={() => this.handleCheckboxChange(card.id, valve)}
                        />
                        Valve {valveIndex + 1}
                      </label>
                    )
                  )}
                </div>


                {this.props.details.automation == "1" ?
                  <input
                    type="number"
                    className="form-control"
                    style={textBoxStyle}
                    placeholder="Enter Minutes"
                    value={card.duration_minute}
                    onChange={(e) => this.handleDurationChange(card.id, e.target.value)}
                  />
                  :
                  <>
                    <TimePicker
                      value={card.start_time != null ? moment(card.start_time, format) : card.start_time}
                      format={format}
                      onChange={(time, timeString) =>
                        this.handleTimeChangeBatchStartSun(card.id, time, timeString)
                      }
                      size="large" />
                    <TimePicker
                      value={card.stop_time != null ? moment(card.stop_time, format) : card.stop_time}
                      format={format}
                      onChange={(time, timeString) =>
                        this.handleTimeChangeBatchStopSun(card.id, time, timeString)
                      }
                      size="large" />
                  </>
                }

                {/* Remove Button */}
                <button
                  className="btn btn-danger mt-3"
                  onClick={() => this.handleRemoveCard(card.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ExportDeviceSettingsMobileStarterBatch;
